import React from 'react'
import SVG from '@/components/SvgIcon'

const Cart = (props) => (
  <SVG {...props}>
    <path d="M19.12,6.93a1,1,0,0,0-1-.93h-2V5.81a4.06,4.06,0,0,0-4.15-4,4.06,4.06,0,0,0-4.15,4V6h-2a1,1,0,0,0-1,.93L4.15,20.79a1,1,0,0,0,1,1.21h13.7a1,1,0,0,0,1-1.21Zm-10-1.12A2.76,2.76,0,0,1,12,3.15a2.76,2.76,0,0,1,2.85,2.66V6H9.15ZM5.46,20.7,6.17,7.3H7.85V11h1.3V7.3h5.7V11h1.3V7.3h1.68l.71,13.4Z"></path>
  </SVG>
)

export default Cart
